import React, { Component } from 'react'
import { StatusInfo } from 'grommet-icons';
import { withRouter } from "react-router-dom";
import { Box, /*Paragraph,*/ Text, TextInput, Button } from 'grommet';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import {ERRORMESSAGE} from '../Constants.js';
import { ValidateMerchantCtrl } from '../Controllers/Account/Registrazione/ValidateMerchantCtrl.js';
import { ValidatePVCtrl } from '../Controllers/Account/Registrazione/ValidatePVCtrl.js';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, passwordRegex, usernameRegex } from '../Utils/Utility';


class Error extends React.Component {

    render() {
        
        return(
            <Box>
                { this.props.testo ? <Text className='error preline' style={{lineHeight:'15px', margin:'10px 0px'}}>{this.props.testo}</Text> : ''}
            </Box>
        );
    }
  }

class InsertUserandPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            userValid: false,
            pwdValid: false,
            password: '',
            disableButton: true,
            error: false,
            loading: false,
            msguser:'',
            msgpass:'',
            showTimeoutModal: false,
            status:''
        }
        this.setUsername = this.setUsername.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.goToOTP = this.goToOTP.bind(this);
    }

    activeBtn(usr, pwd) {

        if(usr && pwd) {
            this.setState({
                disableButton: false
            })
        } else {
            this.setState({
                disableButton: true
            })
        }
    }

    validUsername(user, pwd) {
        var username = user;
        var password = pwd;

        var msg = '';
        var pass= this.state.pwdValid;
        var usr = false;

        if(username === ''){
                                    
            msg = ERRORMESSAGE.msgblank;
            usr = false;

        } else if(username === password) {
                                     
            msg = ERRORMESSAGE.msguserpass;
            usr = false;

        } else if(username !== '' && usernameRegex.test(username) && username.length < 8 && username.length > 20) {
            
            msg = ERRORMESSAGE.msgErrorReq;
            usr = false;

        } else if(username !== '' && !usernameRegex.test(username)) { // Validazione username

            msg = ERRORMESSAGE.msgErrorReq;
            usr = false;

        }  else if(username !== '' && usernameRegex.test(username)) {
                        
            msg = '';
            usr = true;
        }

        this.setState({
            msguser: msg,
            userValid: usr
        })

        this.activeBtn(usr, pass);
    } 

    validPassword(user, pwd) {
        var username = user;
        var password = pwd;
        var msg = '';
        var pass= false;
        var usr = this.state.userValid;

        if (password === ''){

            msg = ERRORMESSAGE.msgblank;
            pass = false;

        } else if(username === password) {

            msg = ERRORMESSAGE.msguserpass;
            pass = false;

        } else if( password !== '' && !passwordRegex.test(password)) { // Validazione password

            msg = ERRORMESSAGE.msgErrorReq;
            pass = false;

        } else if(password !== '' && passwordRegex.test(password)) {

            msg = '';
            pass = true;

        }
        
        this.setState({
            msgpass: msg,
            pwdValid: pass
        })  

        this.activeBtn(usr, pass);
    }

    setUsername(e) {
        var user = e.target.value;
        var pwd = this.state.password;

        this.setState({
            username: user
        }, 
        this.validUsername(user,pwd)
        )
    }

    compareUserAndPassword(){
        let user = this.state.username;
        let password = this.state.password;
        if(user === password) {
            this.setState({
                error: true
            })
        }
    }

    setPassword(e) {
        var user = this.state.username;
        var pwd = e.target.value;
        this.setState({
            password: pwd
        },
        this.validPassword(user,pwd)
        )
    }


    goToOTP() {
        var ids = sessionStorage.getItem('ids')
        const self = this;

        this.setState({
            loading: true
        });

        if(this.props.location.state.code === 'society') {
            ValidateMerchantCtrl(function (data, status) {   
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                }, function(){
                    if(status === 200){
                        this.props.history.push({
                            pathname: '/OTPCodeReg',
                            state: this.state,
                            code: 'society',
                            numtel: this.props.location.state.numtel,
                            email: this.props.location.state.email,
                            step: 3
                        })
                    }
                });
                
            }, function (error) {
                self.setState({
                    status: error,
                    loading: false
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPageReg',
                            state: this.state,
                            code: 'society',
                            numtel: this.props.location.state.numtel,
                            step: 3
                        })  
                    }  else if (this.state.status === 401){
                        this.setState({
                            showTimeoutModal: true
                        })
                    }
                })
            
            }, this.state, ids);
        } else {
            ValidatePVCtrl(function (data, status) {
                self.setState({
                    data: data,
                    status: status,
                    loading: false
                }, function(){
                    if(status === 200){
                        this.props.history.push({
                            pathname: '/OTPCodeReg',
                            state: this.state,
                            code: 'shop',
                            numtel: this.props.location.state.numtel,
                            email: this.props.location.state.email,
                            step: 3
                        })
                    }
                });
               
            }, function (error) {
                self.setState({
                    status: error,
                    loading: false
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPageReg',
                            state: this.state,
                            code: 'shop',
                            numtel: this.props.location.state.numtel,
                            step: 3
                        })  
                    }  else if (this.state.status === 401){
                        this.setState({
                            showTimeoutModal: true
                        })
                    }
                })
               
            }, this.state, this.props.location.state.email, ids);
        }
    }

    componentWillMount(){
        if(this.props.location.step !== 2){
            this.props.history.push({
                pathname: '/login'
            })
        }
    }

    render() {
        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Header />

                <Box direction="column" align='center' className='background-color'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Inserisci Username e Password</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>

                    <Box direction='column' style={{ margin: '30px 0 50px', width: '325px' }}>
                        <div style={{ height:'100px', textAlign: 'left' }}>
                            <Text className='label'>USERNAME</Text>
                            <div  style={{ display:'inline-flex' }}>
                                <TextInput maxLength={20} id='username' size='medium' className='inputFormdisp textInline' onChange={this.setUsername} />
                                <div className="tooltip"><StatusInfo className="iconTooltip" aria-label="Informazioni sul nome utente"/><span className="tooltiptext">{ERRORMESSAGE.msgusernamereg}</span></div>
                            </div>
                            <Error testo={this.state.msguser}/>
                        </div>

                        <div style={{ height:'100px', textAlign: 'left' }}>
                            <Text className='label'>PASSWORD</Text>
                            <div  style={{ display:'inline-flex' }}>
                                <TextInput id='password' type='password' maxLength={20} size='medium' className='inputFormdisp textInline' onChange={this.setPassword}/>
                                <div className="tooltip"><StatusInfo className="iconTooltip" aria-label="Requisiti password"/>
                                    <span className="tooltiptext">
                                        La password deve essere compresa tra 8 e 20 caratteri e deve soddisfare almeno 3 di queste regole:
                                            <br/>- Lettere maiuscole[A-Z]
                                            <br/>- Lettere minuscole[a-z]
                                            <br/>- Almeno un numero[0-9]
                                            <br/>- Almeno un carattere speciale (~!@#$^*()-_=+[]&#10100;&#10101;|;:,.&lt;&gt;/?'"`)
                                    </span>
                                </div>
                            </div> 
                            <Error testo={this.state.msgpass}/>
                        </div>
                    </Box>


                    <Box className='informativa' align='center'>
                        <Button /*onClick={this.showModal}*/ className={this.state.disableButton ? 'btnform disabled' : 'btnform'} label='AVANTI' disabled={this.state.disableButton} onClick={this.goToOTP}/>
                    </Box>
                    
                    {this.state.loading ? loader : ''}
                </Box>
                <Footer />
            </Box >
        )
    }
}


export default InsertUserandPassword = withRouter(InsertUserandPassword)